<template>
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 32C4.5 54.4 23.1667 60 32.5 60C41.8333 60 60.5 54.4 60.5 32C60.5 9.6 41.8333 4 32.5 4C23.1667 4 4.5 9.6 4.5 32Z"
      stroke="white"
      stroke-width="2.5"
    />
    <path
      d="M31.337 17.05V26.25L32.9823 32L34.0791 26.25V17.05M31.337 17.05C29.8746 15.325 28.3756 11.3 34.0791 9C32.4336 10.15 33.531 11.875 34.6278 13.6C35.5053 14.98 34.6276 16.475 34.0791 17.05M31.337 17.05H34.0791"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M44.5752 36.879L37.8977 33.4246L32.9215 32.8173L36.5597 36.0109L43.2372 39.4653M44.5752 36.879C46.5408 36.1474 50.1936 36.2449 49.0799 42.488C49.0482 40.5042 47.2607 40.8915 45.4735 41.2783C44.0437 41.5877 43.3869 40.1986 43.2372 39.4653M44.5752 36.879L43.2372 39.4653"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
